import * as types from '../../../constants/actionTypes';

const initialState = {
    loaded: false,
    loading: false,
    userCompanies: [],
    selectedCompany: null,
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case types.FETCH_USER_COMPANIES:
            return {
                ...state,
                loading: true,
            };
        case types.FETCH_USER_COMPANIES_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true,
                userCompanies: action.result,
            };
        case types.FETCH_USER_COMPANIES_FAIL:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: action.error,
            };

        case types.CREATE_PROFILE_SUCCESS:
            return {
                ...state,
                createdCompanyProfile: action.result,
            };

        case types.COMPANY_SELECTED:
            return {
                ...state,
                selectedCompany: action.selectedCompany,
            };

        default:
            return state;
    }
}
